<template>
  <div class="bar-container">
    <div class="bar-line-title">
      <mf-icon v-if="!hideDot" fill small :color="color">fiber_manual_record</mf-icon>
      <div v-if="isIndustry">
        <span v-if="percentage > 0" class="coupons-number" :style="{ color }">{{ percentage | localeString(2) }}% ({{ value | localeString(0) }})</span>
        <span v-else class="coupons-number" :style="{ color }">{{ value | localeString(0) }}</span>
      </div>
      <div v-else class="coupons-cbm d-flex align-center">
        <span class="coupons-cbm-number" :style="{ color }">{{ value | localeString(0) }}</span>
        <span class="coupons-cbm-percentage" :style="{ color }">({{ percentage | localeString(2) }}%)</span>
      </div>
      <span class="description-text-color">{{ description }}</span>
      <tooltip :disabled="!tooltip" :message="tooltip">
        <mf-icon v-if="tooltip" small color="grey">info</mf-icon>
      </tooltip>
    </div>
    <div v-if="!hideBar" class="bar-and-number">
      <div class="bar" :style="{ backgroundColor: color, width: calcBarWidth }">
        <span v-if="percentage > 0">{{ percentage | localeString(2) }}%</span>
      </div>
      <span v-if="value > 0" class="coupons-number" :style="{ color }">{{ value | localeString(0) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressFunnelBar',
  components: {
    Tooltip: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'),
  },
  props: {
    color: {
      type: String,
      default: '#969ea7',
    },
    percentage: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    value: {
      type: Number,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
      default: null,
    },
    hideBar: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDot: {
      type: Boolean,
      required: false,
      default: false,
    },
    barWidth: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    isIndustry: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    calcBarWidth() {
      if (this.hideBar) return '0%'
      return `calc(50px + ${this.barWidth}%)`
    },
  },
}
</script>

<style lang="scss" scoped>
.bar-container {
  display: flex;
  flex-direction: column;
  gap: 6px;

  .bar-line-title {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .coupons-number {
    font-size: 18px;
    font-weight: 700;
  }
  .coupons-cbm-number {
    font-size: 22px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0.01em;
    margin-right: 2px;
  }
  .coupons-cbm-percentage {
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
  }

  .description-text-color {
    font-size: 16px;
    color: #6b7580;
  }

  .bar-and-number {
    display: flex;
    align-items: center;
    gap: 16px;

    .bar {
      border-radius: 8px;
      height: 32px;
      padding: 6px 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: white;
      font-size: 16px;
    }
  }
}
</style>
